<div class="modal-header">
	<h4 class="modal-title">
		<span *ngIf="selectedArticles.length === 1">Tiedoston tagit</span>
		<span *ngIf="selectedArticles.length > 1"
			>Lisää tagit valittuihin tiedostoihin</span
		>
	</h4>
	<button
		type="button"
		class="btn-close"
		aria-label="Close"
		(click)="close()"
		[disabled]="isLoading"
	></button>
</div>

<div class="modal-body">
	<p>
		<span *ngIf="selectedArticles.length === 1">
			Muokkaa tiedoston "{{
				selectedArticles[0] && selectedArticles[0].title
			}}" tageja:
		</span>
		<span *ngIf="selectedArticles.length > 1">
			Lisää tagit {{ selectedArticles.length }} valittuun tiedostoon:
		</span>
	</p>

	<!-- Current tags for single file -->
	<!-- <div
		class="current-tags-section mb-3"
		*ngIf="
			selectedArticles.length === 1 && getCurrentArticleTags().length > 0
		"
	>
		<h6 class="text-muted">Tiedoston nykyiset tagit</h6>
		<div class="current-tags-list">
			<span
				*ngFor="let tagId of getCurrentArticleTags()"
				class="badge bg-primary text-white me-2 mb-2"
			>
				{{
					sourceMaterialService.GetTagById(tagId)?.name ||
						"Unknown Tag"
				}}
			</span>
		</div>
	</div> -->

	<!-- Olemassa olevat tagit -->
	<div
		class="existing-tags-section mb-3"
		*ngIf="
			sourceMaterialService.Tags && sourceMaterialService.Tags.length > 0
		"
	>
		<div class="d-flex justify-content-between align-items-center mb-2">
			<h6 class="text-muted mb-0">Valitse tagit</h6>
			<button
				type="button"
				class="btn btn-light btn-sm"
				(click)="openTagManagement()"
				[disabled]="isLoading"
				title="Hallinnoi tageja"
			>
				<i class="bi bi-gear"></i>
			</button>
		</div>
		<div class="existing-tags-list">
			<span
				*ngFor="let tag of sortedTags"
				class="badge bg-light text-dark me-2 mb-2 existing-tag"
				[class.selected]="selectedTagIds.includes(tag.id)"
				(click)="toggleExistingTag(tag)"
				role="button"
				tabindex="0"
				[attr.aria-label]="
					selectedTagIds.includes(tag.id)
						? 'Poista tagi: ' + tag.name
						: 'Lisää tagi: ' + tag.name
				"
			>
				{{ tag.name }}
				<i
					class="bi bi-plus-circle ms-1"
					*ngIf="!selectedTagIds.includes(tag.id)"
				></i>
				<i
					class="bi bi-x-circle ms-1"
					*ngIf="selectedTagIds.includes(tag.id)"
				></i>
			</span>
		</div>

		<div class="d-block w-100 text-center mt-3 mb-3 text-muted text-small">
			tai
		</div>

		<div class="input-group input-group-sm w-50 ms-auto me-auto">
			<span class="input-group-text" id="hashtag">#</span>

			<input
				type="text"
				class="form-control"
				placeholder="Luo uusi tagi..."
				[(ngModel)]="currentTagInput"
				(keyup.enter)="addTag()"
				[disabled]="isCreatingTag"
			/>
			<button
				class="btn btn-outline-secondary"
				type="button"
				(click)="addTag()"
				[disabled]="isCreatingTag"
			>
				<span
					*ngIf="isCreatingTag"
					class="spinner-border spinner-border-sm me-1"
					role="status"
					aria-hidden="true"
				></span>
				<i class="bi bi-plus" *ngIf="!isCreatingTag"></i> Lisää
			</button>
		</div>

		<!-- <small class="form-text text-muted">
			<span *ngIf="selectedArticles.length === 1">
				Tag luodaan ja lisätään tiedostoon
			</span>
			<span *ngIf="selectedArticles.length > 1">
				Tag luodaan ja lisätään valittuihin tiedostoihin
			</span>
		</small> -->
	</div>
</div>

<div class="modal-footer">
	<button
		type="button"
		class="btn btn-outline-secondary"
		(click)="close()"
		[disabled]="isLoading"
	>
		Peruuta
	</button>
	<button
		type="button"
		class="btn btn-primary"
		(click)="addTagsToSelectedArticles()"
		[disabled]="isLoading || !hasChanges()"
	>
		<span
			*ngIf="isLoading"
			class="spinner-border spinner-border-sm me-2"
			role="status"
			aria-hidden="true"
		></span>
		<span *ngIf="isLoading">
			<span *ngIf="selectedArticles.length === 1">Tallennetaan...</span>
			<span *ngIf="selectedArticles.length > 1">Lisätään...</span>
		</span>
		<span *ngIf="!isLoading">
			<span *ngIf="selectedArticles.length === 1"
				>Tallenna muutokset</span
			>
			<span *ngIf="selectedArticles.length > 1">Lisää tagit</span>
		</span>
	</button>
</div>
